<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 48 48" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path
        data-follow-fill="currentColor"
        d="M41.6 31.3c-.9.7-1.5 1.1-2.9 1.1s-2-.5-2.8-1.1c-1-.7-2.2-1.6-4.5-1.6s-3.5.9-4.5 1.6c-.9.7-1.5 1.2-2.9 1.2s-2-.5-2.8-1.1c-1-.7-2.2-1.6-4.5-1.6s-3.5.9-4.5 1.6c-.8.6-1.5 1.1-2.8 1.1s-2-.5-2.8-1.1c0 0-.1 0-.1-.1.8-.9 1.8-1.7 3-2.4.9-.6 1.9-1.2 3-1.6 1.5-.7 3.1-1.2 4.8-1.5 2.1-.5 4.3-.7 6.7-.7 2.4 0 4.7.2 6.8.7 1 .2 2 .5 2.9.8 3.2 1 6 2.7 7.9 4.7zM35.1 2v11c0 6-4.9 11-11 11s-11-5-11-11S18 2 24.1 2h11zm8.2 32.5c-.8.3-1.3.8-1.8 1.1-.9.6-1.5 1.1-2.8 1.1s-2-.5-2.9-1.1c-1-.7-2.2-1.7-4.5-1.7s-3.5.9-4.5 1.7c-.8.6-1.5 1.1-2.8 1.1-1.4 0-2-.5-2.8-1.1-1-.7-2.2-1.7-4.5-1.7s-3.5.9-4.5 1.7c-.9.6-1.5 1.1-2.8 1.1s-2-.5-2.8-1.1c-.7-.5-1.4-1.1-2.6-1.4-.6-.1-1.3-.2-2-.2v2.8c.5 0 .8 0 1.2.1.6.2 1.1.5 1.7 1 1 .7 2.2 1.7 4.5 1.7s3.5-.9 4.5-1.7c.9-.6 1.5-1.1 2.8-1.1 1.4 0 2 .5 2.8 1.1 1 .7 2.2 1.7 4.5 1.7s3.5-.9 4.5-1.7c.8-.6 1.5-1.1 2.8-1.1s2 .5 2.9 1.1c1 .7 2.2 1.7 4.5 1.7s3.5-.9 4.5-1.7l.9-.6c.5-.3 1.1-.5 2-.5V34c-1.2 0-2.1.2-2.8.5zm.7 6.3c-1.1.3-1.9.9-2.5 1.4-.9.6-1.5 1.1-2.8 1.1s-2-.5-2.9-1.1c-1-.7-2.2-1.6-4.5-1.6s-3.5.9-4.5 1.6c-.8.6-1.5 1.1-2.8 1.1-1.4 0-2-.5-2.8-1.1-1-.7-2.2-1.6-4.5-1.6s-3.5.9-4.5 1.6c-.9.6-1.5 1.1-2.8 1.1s-2-.5-2.8-1.1c-.8-.6-1.8-1.3-3.4-1.6-.3 0-.7-.1-1.1-.1v2.8c1 0 1.6.2 2.2.6.2.1.4.3.7.5.8.7 2 1.6 4.3 1.6s3.5-.9 4.5-1.7c.9-.6 1.5-1.1 2.8-1.1 1.4 0 2 .5 2.8 1.1 1 .7 2.2 1.7 4.5 1.7s3.5-.9 4.5-1.7c.8-.6 1.5-1.1 2.8-1.1s2 .5 2.9 1.1c1 .7 2.2 1.7 4.5 1.7h.8c.3 0 .6-.1.9-.2.1 0 .2 0 .2-.1.1 0 .3-.1.4-.1.9-.3 1.5-.8 2-1.2.9-.6 1.5-1.1 2.8-1.1v-2.8c-.5 0-1.1.1-1.7.3z"
        :fill="_fill"
      />
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
